import apiClient from './apiClient';

export async function fetchExports() {
  const { data } = await apiClient.get('/data/exports');
  return data;
}

export async function requestExport(scope) {
  const { data } = await apiClient.post('/data/exports', { scope });
  return data;
}

export async function fetchExportDetail(id) {
  const { data } = await apiClient.get(`/data/exports/${id}`);
  return data;
}

export function downloadExportResult(job) {
  const blob = new Blob([job.resultJson || '{}'], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `data-export-${job.id}.json`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
